import * as wxu from '@/utils/wx-utils.js'
import { Dialog } from 'vant';

const pu =
{
    RandomStrId : ()=>
    {
        var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        var ret = '';
        for (var i = 0; i < 16; i++) {
            ret += $chars.charAt(Math.floor(Math.random() * $chars.length));
        }
        return ret;
    },

    RedirectWXLogin : ()=>
    {
        wxu.redirectWX('')
    },

    CheckIPhone : ()=>{
        const userAgent = navigator.userAgent.toLowerCase();
        return (
            userAgent.includes('iphone') ||
            userAgent.includes('ipod') ||
            (userAgent.includes('ipad') && !userAgent.includes('android'))
        );
    },

    PublicConfirm(msg, opt)
    {
        var cfmTxt = '好的'
        var cancelTxt = '取消'
        if(opt) {
            if(opt.confirm) {
                cfmTxt = opt.confirm
            }
            if(opt.cancel) {
                cancelTxt = opt.cancel
            }
        }
        return Dialog.confirm({
            title: '温馨提示',
            message: msg,
            confirmButtonText:cfmTxt,
            cancelButtonText:cancelTxt,
            allowHtml:true,
        })
    },
}

export default
{
    install: (app) => {
        app.config.globalProperties['$pu'] = pu
    }
}
